import avo from 'analytics/avo';
import isClient from 'commons/isClient';
import avoInspector from 'analytics/avoInspector';
import RudderstackAvoDestination from 'analytics/RudderstackAvoDestination';
import getEnvValue from 'commons/getEnvValue';

const environmentName = getEnvValue('NEXT_PUBLIC_ENV_NAME') || '';

const initAvo = () => {
  if (isClient()) {
    avo.initAvo(
      {
        env:
          environmentName === 'dev' ||
          environmentName === 'test' ||
          environmentName === 'stg' ||
          environmentName === 'local'
            ? 'dev'
            : environmentName.includes('prod')
            ? 'prod'
            : environmentName,
        inspector: avoInspector,
        strict: false,
      },
      {
        userAgent: navigator.userAgent,
      },
      null,
      RudderstackAvoDestination
    );
  }
};

export default initAvo;
